import { createFileRoute } from "@tanstack/react-router";
import Accesibilitate from "@/pages/legal/Accesibilitate";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/accesibilitate/")({
  head: () => routeHead("/accesibilitate/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Accesibilitate />
  );
}
